module.exports = __webpack_public_path__ + "static/media/garden-vue.9416bab2.jpg";